import React from 'react'
import PropTypes from 'prop-types'
import { Box, IconButton, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import ChevronLeftIcon from 'components/material-symbol/icons/ChevronLeft'
import ChevronRightIcon from 'components/material-symbol/icons/ChevronRight'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  label: {
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.text.secondary,
  },
  navButton: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    padding: 6,
    '&.Mui-disabled': {
      borderColor: theme.palette.divider,
      opacity: 0.4,
    },
  },
}))

export default function StudentsTablePagination({
  page,
  pageCount,
  rowsPerPage,
  totalCount,
  onPageChange,
}) {
  const classes = useStyles()

  if (totalCount === 0) return null

  const from = page * rowsPerPage + 1
  const to = Math.min((page + 1) * rowsPerPage, totalCount)

  return (
    <Box className={classes.root}>
      <Typography className={classes.label}>
        {from} - {to} of {totalCount}
      </Typography>
      <IconButton
        className={classes.navButton}
        size="small"
        aria-label="Previous page"
        disabled={page <= 0}
        onClick={() => onPageChange(page - 1)}
      >
        <ChevronLeftIcon fontSize="small" />
      </IconButton>
      <IconButton
        className={classes.navButton}
        size="small"
        aria-label="Next page"
        disabled={page >= pageCount - 1}
        onClick={() => onPageChange(page + 1)}
      >
        <ChevronRightIcon fontSize="small" />
      </IconButton>
    </Box>
  )
}

StudentsTablePagination.propTypes = {
  page: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
}
